module.exports = __webpack_public_path__ + "static/media/codepin-resource-wall.1e7d1e93.png";